import PropTypes from "prop-types";
import {
  appearancePropType,
  classNamePropType,
  childrenPropType,
  disabledPropType,
  onClickPropType,
  titlePropType,
  justifyPropType,
  sizePropType,
  shapePropType,
  iconPropType,
} from "../../common";

/**
 * PropTypes for Button component
 *
 * @property {('default'|'primary'|'primary-elevated'|'primary-outline'|'secondary'|'success'|'danger'|'warning'|'info')} [appearance] - Visual style variant
 * @property {string} [className] - Additional CSS classes
 * @property {React.ReactNode} [children] - Button content (text or icon)
 * @property {boolean} [disabled] - Disable button interaction
 * @property {function} [onClick] - Click handler callback
 * @property {string} [title] - Button text (alternative to children)
 * @property {('flex-start'|'center'|'flex-end'|'space-between'|'space-around'|'space-evenly')} [justify] - Content justification
 * @property {number} [radius] - Border radius in pixels
 * @property {boolean} [isBlock] - Full width block button
 * @property {('small'|'default'|'medium'|'large')} [size] - Button size variant
 * @property {('circle'|'square'|'rounded')} [shape] - Button shape for icon buttons
 * @property {React.ReactNode} [iconBefore] - Icon before text
 * @property {React.ReactNode} [iconAfter] - Icon after text
 */
export const buttonPropTypes = {
  appearance: appearancePropType,
  className: classNamePropType,
  children: childrenPropType,
  disabled: disabledPropType,
  onClick: onClickPropType,
  title: titlePropType,
  justify: justifyPropType,
  radius: PropTypes.number,
  isBlock: PropTypes.bool,
  size: sizePropType,
  shape: shapePropType,
  iconBefore: iconPropType,
  iconAfter: iconPropType,
};
